// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes Loading_pulse__d1FcC {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.85;
  }
}
.Loading_loadingContainer__mkbzc {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.Loading_fullscreen__0qlT7 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 9999;
}

.Loading_inline__l0Tzp {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 150px;
}

.Loading_content__LOZaN {
  text-align: center;
}

.Loading_logo__xNJeu {
  max-width: 180px;
  height: auto;
  animation: Loading_pulse__d1FcC 2s ease-in-out infinite;
}

.Loading_text__YG9H8 {
  margin-top: 1.5rem;
  font-size: 1rem;
  color: #445867;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Loading/Loading.module.scss"],"names":[],"mappings":"AAAA;EACE;IACE,mBAAA;IACA,UAAA;EACF;EACA;IACE,qBAAA;IACA,aAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAAF;;AAIA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,0CAAA;EACA,aAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,uDAAA;AADF;;AAIA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AADF","sourcesContent":["@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.1); \n    opacity: 0.85;      \n  }\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n\n.fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(255, 255, 255, 0.8); \n  z-index: 9999; \n}\n\n.inline {\n  position: relative; \n  width: 100%;\n  height: 100%;\n  min-height: 150px;\n}\n\n.content {\n  text-align: center;\n}\n\n.logo {\n  max-width: 180px; \n  height: auto;\n  animation: pulse 2s ease-in-out infinite; \n}\n\n.text {\n  margin-top: 1.5rem;\n  font-size: 1rem;\n  color: #445867; \n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `Loading_loadingContainer__mkbzc`,
	"fullscreen": `Loading_fullscreen__0qlT7`,
	"inline": `Loading_inline__l0Tzp`,
	"content": `Loading_content__LOZaN`,
	"logo": `Loading_logo__xNJeu`,
	"pulse": `Loading_pulse__d1FcC`,
	"text": `Loading_text__YG9H8`
};
export default ___CSS_LOADER_EXPORT___;
